import { render, staticRenderFns } from "./Opensource.vue?vue&type=template&id=69d41b15&scoped=true&"
var script = {}
import style0 from "./Opensource.vue?vue&type=style&index=0&id=69d41b15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d41b15",
  null
  
)

export default component.exports